<template>
  <f7-page name="ccm-course-list" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        내 학습과정 목록
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>학습과정 목록</f7-block-title>
		<div class="list">
			<ul>
				<li v-for="(item,i) in courseList" :key="'i'+i">
					<a href="#" class="item-link" @click="goCourseItem(i)">
						<div class="item-content item-inner" >
							<div style="padding:4px; width:100%;">
								<span class="study-course-title">
									{{getCourseName(i)}}
								</span>
								<div class="study-progress-red">
									<span class="title1" v-bind:style="getCalcStyle(item.START_SUNIT_SEQ, item.SUNIT_CNT)">
										{{item.START_SUNIT_NAME}}
									</span>
									<study-progress :unit-count="item.SUNIT_CNT" :start-percent="((item.START_SUNIT_SEQ-1) * 100 / item.SUNIT_CNT)" :end-percent="(item.END_SUNIT_SEQ * 100 / item.SUNIT_CNT)">
									</study-progress>
									<span class="title2" v-bind:style="getCalcStyle(item.END_SUNIT_SEQ, item.SUNIT_CNT)">
										{{item.END_SUNIT_NAME}}
									</span>

								</div>
							</div>
							<!--	
							<div style="padding:4px; width:100%;">
								<span style="vertical-align:middle; font-size:28px;">
									<b>{{getCourseName(i)}}</b>
								</span>
								<span v-if="item.PUT_CNT > 0" class="badge color-primary" style="vertical-align:middle">{{item.PUT_CNT}}</span>
								<course-progress :value-title="item.END_SUNIT_NAME" :unit-count="item.SUNIT_CNT" :start-percent="((item.START_SUNIT_SEQ-1) * 100 / item.SUNIT_CNT)" :end-percent="(item.END_SUNIT_SEQ * 100 / item.SUNIT_CNT)"></course-progress>
							</div>
							-->
							
							<div class="item-after">상세보기</div>
						</div>
					</a>
				</li>			
			</ul>
		</div>
  </f7-page>
</template>

<script>
import StudyProgress from '../../../components/progress/study-progress';
import MODULE from '../../../js/common/module';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	components: {
		StudyProgress
	},
  data() {
    return {
			courseList: [],
			firstLogin : false
    }
  },
  mounted() {
		const _this = this;
		try {			
			_this.firstLogin = _this.$f7route.context.firstLogin;

			if(_this.firstLogin){
				_this.getStudyPlanInfo();
			}

		} catch(e) {
			_this.loadMyCourseList();
		}
				
		//this.loadMyCourseList();
		

		// 매우 많이 호출된다.
    //$(document).on('page:init page:reinit', '.page[data-name="ccm-course-list"]', this.onPageShow);
  },
  methods: {
		onPageShow() {
			
		},
		getCalcStyle(unitCnt, sunitCnt){
			const _this = this;
			
			var calcStyle="";
			var leftValue = (unitCnt * 100) / sunitCnt;
			var transformValue = (unitCnt * 100) / sunitCnt;
			
			calcStyle = "left:"+leftValue+"%;transform:translateX(-"+transformValue+"%)";
			
			return calcStyle;
		},
		getStudyPlanInfo() {
			const _this = this;
			let planStudyInfo = AUTH.localGetPlanStudyInfo();

			if(!MODULE.Util.isEmpty(planStudyInfo)) {
					/*
					MODULE.DialogBox.okcancel(
						"알림","최근 플래너 학습 내역이 있습니다. 학습 화면으로 이동할까요?",	
							function() {
								var url = PAGES.MENU_CCM_STUDY_PLAN_DAY;

								var param = {
									plannerKey : planStudyInfo.PLANNER_KEY,
									timesNo : planStudyInfo.TIMES_NO,
									gradeId : planStudyInfo.GRADE_ID,
									semesterId : planStudyInfo.SEMESTER_ID,
									reviseId : planStudyInfo.REVISE_ID,
									groupKey : planStudyInfo.GROUP_KEY,
									studyStep : planStudyInfo.STUDY_STEP,
									loginFlg : planStudyInfo.LOGIN_FLG
								}			
							
								PAGES.goPage(url,param);																					

							},function() {													
          			_this.loadMyCourseList();	
							}
					);
					*/

					MODULE.DialogBox.timerDialog(
					"알림","최근 플래너 학습 내역이 있습니다. 학습 화면으로 이동할까요?",	
						function() {
							var url = PAGES.MENU_CCM_STUDY_PLAN_DAY;

							var param = {
								plannerKey : planStudyInfo.PLANNER_KEY,
								timesNo : planStudyInfo.TIMES_NO,
								gradeId : planStudyInfo.GRADE_ID,
								semesterId : planStudyInfo.SEMESTER_ID,
								reviseId : planStudyInfo.REVISE_ID,
								groupKey : planStudyInfo.GROUP_KEY,
								studyStep : planStudyInfo.STUDY_STEP,
								loginFlg : planStudyInfo.LOGIN_FLG
							}			
						
							PAGES.goPage(url,param);																					

						},function() {													
							_this.loadMyCourseList();	
						}
				);
			
			} else {
				_this.loadMyCourseList();
			}
		},
		loadMyCourseList() {
			var _this = this;

			let param = {
			};

			API.ajaxRequest({
				url: API.getMyCourseListUrl(),
				data: param
			}).then(function (data) {
				_this.courseList = data.courseList;
			}).catch(function (code) {
				
				/*
				var beforeFunction = function(code, PAGES, AUTH) {
					if (code == CONST.resultCode.TOKEN_EXPIRED) {
						// 결제하세요.
						return CONST.STOP_CATCH;
					}
				}
				*/

				//MODULE.UITool.catchBlock(code, PAGES, AUTH, beforeFunction);
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		getCourseName(itemIndex) {
			var item = this.courseList[itemIndex];
			var courseId = item.GRADE_ID + item.SEMESTER_ID;
			var courseName = CONST.courseMap[courseId].name;
	
			return courseName + "(" + item.REVISE_ID + "개정)";
		},
    goCourseItem(itemIndex) {
			var item = this.courseList[itemIndex];

			var url = PAGES.SUB_CCM_COURSE_DASHBOARD;

			var param = {
				gradeId : item.GRADE_ID,
				semesterId : item.SEMESTER_ID,
				reviseId : item.REVISE_ID
			}

			PAGES.popPage(url, param);
		}
  }
}

</script>